export default __webpack_public_path__ + "static/media/Activities.67646842.svg";